<mat-card appearance="outlined">
	<mat-card-title [innerText]="'MAIN_APP_DIALOG.FILE_NAME_DIALOG.title' | translate"></mat-card-title>
	<mat-card-content>
		<span class="row">
			<mat-form-field style="text-align: center; flex: 3;">
				<mat-label [innerText]="'MAIN_APP_DIALOG.FILE_NAME_DIALOG.name' | translate"></mat-label>
				<input (keydown)="enterPressed($event)" [(ngModel)]="name" matInput style="text-align: center" type="text"/>
			</mat-form-field>
			<mat-form-field style="text-align: center; flex: 1;">
				<mat-label [innerText]="'MAIN_APP_DIALOG.FILE_NAME_DIALOG.extension' | translate"></mat-label>
				<input [(ngModel)]="extension" [disabled]="true" matInput style="text-align: center" type="text"/>
			</mat-form-field>
		</span>
	</mat-card-content>
	<mat-dialog-actions>
		<button (click)="closeDialog(true)" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.save' | translate" class="confirm" mat-dialog-close mat-stroked-button></button>
		<button (click)="closeDialog(false)" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate" class="cancel" mat-stroked-button></button>
	</mat-dialog-actions>
</mat-card>
